import React from "react";
import { colors } from './colors/color';
import { Icon, iconName } from "./icons/Icons";
import { Span } from "./typography/Body";
import { Flex } from "./compositeComponents/FlexHelpers";
import styled from "styled-components";

export function InfoCardRow(props:React.PropsWithChildren<{style?: React.CSSProperties}>):JSX.Element
{
    return (
        <StyledInfoCardRow style={props.style}>
            {props.children}
        </StyledInfoCardRow>
    );
}

type InfoCardProps = {
    icon: iconName,
    header:string,
    text: string
}
export function InfoCard(props:InfoCardProps):JSX.Element
{
    return (

        <StyledInfoCard>
            
            <Icon name={props.icon} color={colors.infoCard.icon} backgroundColor={colors.infoCard.iconBackground} />
            
            <Flex flexDirection="column" gap={4}>
                
                <Span size="14px" fontWeight={500} color="normal">{props.header}</Span>                
            
                <div style={{ flex: '1 1 auto', display:'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                    <Span size="12px" color="normal">
                    {props.text}
                    </Span>
                </div>

            </Flex>

        </StyledInfoCard>
    );
}

const StyledInfoCardRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
`;

const StyledInfoCard = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px;
    background-color: ${colors.infoCard.background};
    border-radius: 4px;
    flex: 1 1 0;
`;